import axios from "axios";

import { BASE_URL, LOGIN_URL, fetchHeaders } from "./common";

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = "api/me";

export const login = async (emailId, password) => {
  const params = {
    cmd: "email",
    country: "KR",
    language: "KR",
    emailId,
    password
  };

  const response = await fetch(
    LOGIN_URL,
    {
      method: "POST",
      headers: fetchHeaders,
      body: JSON.stringify(params),
    }
  );

  const json = await response.json();

  return json;

}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
